<template>
  <div class="survey-answer" :class="{
            invalid: !model.valid && canEdit
        }">

    <div class="columns">
        <div class="column">
    
    <h5 class="title is-size-5" v-if="model.header">
        {{ model.header }}
    </h5>

    <p style="white-space: pre-line">
      <span>{{ model.title }}</span>
      <span class="required" v-if="model.required">*</span>
    </p>

    <br>

    <template v-if="model.type == 'radio' || model.type == 'generated-courses'">
      <b-field grouped v-for="option in model.options" :key="option.uuid">
        <template v-if="typeof option.correct == 'boolean' && isQuiz">
            <b-icon
                class="no-print"
                icon="check"
                type="is-success"
                v-if="option.correct"/>
            <b-icon
                class="no-print"
                icon="close"
                type="is-danger"
                v-else/>
            &nbsp;
        </template>
        <b-radio
          :disabled="!canEdit"
          @input="onUpdate"
          :native-value="option.uuid"
          v-model="model.answer"
        >{{ option.title }}</b-radio>
      </b-field>
      <template v-if="modelHasOther">
        <b-field grouped>
          <b-radio
            :disabled="!canEdit"
            @input="onUpdate"
            native-value="other"
            v-model="model.answer"
          ></b-radio>
          <b-input
            :disabled="!canEdit"
            expanded
            maxlength="200"
            :has-counter="false"
            @input="addOther"
            placeholder="Другое..."
            v-model.trim="model.other"
          />
        </b-field>
      </template>
    </template>
    <template v-else-if="model.type == 'checkbox'">
      <b-field grouped v-for="option in model.options" :key="option.uuid">
        <template v-if="typeof option.correct == 'boolean' && isQuiz">
            <b-icon
                class="no-print"
                icon="check"
                type="is-success"
                v-if="option.correct"/>
            <b-icon
                class="no-print"
                icon="close"
                type="is-danger"
                v-else/>
            &nbsp;
        </template>
        <b-checkbox
          :disabled="!canEdit"
          @input="onUpdate"
          :native-value="option.uuid"
          v-model="model.answer"
        >{{ option.title }}</b-checkbox>
      </b-field>
      <template v-if="modelHasOther">
        <b-field grouped>
          <b-checkbox :disabled="!canEdit" @input="onUpdate" v-model="includeOther"></b-checkbox>
          <b-input
            :disabled="!canEdit"
            expanded
            maxlength="200"
            :has-counter="false"
            @input="addOther"
            placeholder="Другое..."
            v-model.trim="model.other"
          />
        </b-field>
      </template>
    </template>
    <template v-else-if="model.type == 'text'">
        <template v-if="!scoreView">
            <textarea-autosize
            :has-counter="false"
            :disabled="!canEdit"
            :class="{
                textarea: true,
                'is-danger': !model.valid
            }"
            maxlength="2000"
            @paste.native.prevent
            @input="onUpdate"
            v-model.trim="model.answer"
            />
        </template>
        <template v-else>
            <b-field label="Ответ" v-if="model.answer">
                <p style="white-space: pre-line">
                    {{ model.answer }}
                </p>
            </b-field>
            <p class="has-text-centered" v-else>Ответ не указан</p>
        </template>
    </template>
    <template v-else-if="model.type == 'short'">
        <template v-if="!scoreView">
            <b-input
                :has-counter="false"
                :disabled="!canEdit"
                :class="{
                    'is-danger': !model.valid
                }"
                maxlength="100"
                @paste.native.prevent
                @input="onUpdate"
                v-model.trim="model.answer"
            />
        </template>
        <template v-else>
            <b-field label="Ответ" v-if="model.answer.length > 0">
                <p>{{ model.answer }}</p>
            </b-field>
            <p class="has-text-centered" v-else>Ответ не указан</p>
        </template>
    </template>

    <small v-if="model.answer_type && survey.score_type == 'points'"
        class="no-print">
        <span v-if="model.answer_type == 'full'">
            Полное соответствие
        </span>
        <span v-else-if="model.answer_type == 'partial'">
            Частичное соответствие (только правильные)
        </span>
        <span v-else-if="model.answer_type == 'partial_any'">
            Частичное соответствие (включая неправильные)
        </span>
    </small>
    
    <p class="required-notice has-text-danger" v-if="!model.valid && canEdit">
        Это обязательный вопрос
    </p>

    <div v-if="openQuestion && scoreView" class="no-print">

        <template v-if="model.answer">

            <br>

            <b-field label="Оценка">
                <answer-score
                    :disabled="!model.answer"
                    :type="survey.score_type"
                    :score-base="scoreBase"
                    v-model="model.score"
                    @input="onScoreUpdate"
                />
            </b-field>

        </template>

    </div>

    <template v-if="modelHasComment
                && (!scoreView || scoreView && model.answer)">

        <br class="no-print">

        <b-field label="Комментарий" class="no-print">
            <textarea-autosize
                v-if="canEdit || scoreView"
                :has-counter="false"
                :class="{
                    textarea: true,
                    'is-danger': !model.valid
                }"
                maxlength="500"
                @input="onCommentUpdate"
                v-model.trim="model.comment"
            />
            <p style="white-space: pre-line" v-else>{{ model.comment }}</p>
        </b-field>

        <b-field label="Комментарий" class="print-only" v-if="model.comment">
            <p style="white-space: pre-line">{{ model.comment }}</p>
        </b-field>

    </template>
    
    <template v-if="model.footer">
        <br>
        <h5 class="title is-size-5">
            {{ model.footer }}
        </h5>
    </template>
            
        </div>
        <div class="column is-1 has-text-centered" v-if="isQuiz && (scoreView || survey.participated)">
            <b-icon icon="help" type="is-info"
                v-if="model.score < 0"/>
            <b-icon icon="check" type="is-success"
                v-else-if="model.score >= scoreBase"/>
            <b-icon icon="minus" type="is-warning"
                v-else-if="model.score > 0"/>
            <b-icon icon="close" type="is-danger"
                v-else/>
            <br>
            <small v-if="model.score >= 0 && model.answer">
                {{ transformScore(model.score) }}
            </small>
        </div>
    </div>

  </div>
</template>

<script>
import uuid from "uuid/v4";
import AnswerScore from "./AnswerScore";

let mounted = false;
let canValidate = false;

export default Vue.extend({
  props: {
    isQuiz: {
      type: Boolean,
      required: false,
      default: false
    },
    scoreView: {
      type: Boolean,
      required: false,
      default: false
    },
    canEdit: {
      type: Boolean,
      required: false,
      default: true
    },
    survey: {
      type: Object,
      required: true
    },
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      scoreBase: 10,
      canEmit: false,
      modelHasComment: false,
      modelHasOther: false,
      includeOther: false,
      model: this.value
    };
  },
  components: { AnswerScore },
  computed: {
    openQuestion() {
      return this.model.type == "text" || this.model.type == "short";
    }
  },
  watch: {
    includeOther(value) {
      this.model.other_selected = value;
    }
  },
  created() {
    this.model.question = this.value.uuid;

    // this.model.type = this.convertGeneratedQuestionType(this.model.type);

    switch (this.model.type) {
      case "radio": {
        this.model.answer = null;
        break;
      }
      case "checkbox": {
        this.model.answer = [];

        break;
      }
      case "text": {
        this.model.answer = this.model.placeholder;
        break;
      }
      case "short": {
        this.model.answer = "";
        break;
      }
    }

    this.modelHasOther = this.model.other == true;
    this.model.other = "";
    if (this.scoreView) {
      this.modelHasComment =
        this.model.type != "radio" && this.model.type != "checkbox";
    } else {
      this.modelHasComment = this.model.comment == true;
    }
    this.model.comment = "";
    // this.model.valid = true;

    this.onUpdate();
  },
  mounted() {
    mounted = true;
  },
  methods: {
    // convertGeneratedQuestionType(type) {
    //     switch (type){
    //         case 'generated-courses': {
    //             return 'radio';
    //         }
    //     }

    //     return type;
    // },
    transformScore(score) {
      switch (this.survey.score_type) {
        case "binary": {
          return score < this.scoreBase ? 0 : 1;
        }
        default: {
          return score;
        }
      }
    },
    onScoreUpdate(score) {
      this.model.score = score;
      if (this.scoreView && this.canEmit) {
        this.$emit("review", this.model);
      }
      this.$forceUpdate();
    },
    onCommentUpdate(comment) {
      if (this.scoreView && this.canEmit) {
        this.$emit("review", this.model);
      }
      if (this.canEmit) {
        this.$emit("update", this.model);
      }
    },
    isCorrect(score) {
      return score >= this.baseScore;
    },
    update(data) {
      if (data) {
        this.model = _.merge(this.value, data);
      } else {
        this.model.score = 0;
      }

      this.$forceUpdate();
      this.$nextTick(() => {
        this.canEmit = true;
      });

      if (this.model.comment && this.isQuiz) {
        this.modelHasComment = this.model.comment.length > 0;
      }
    },
    addOther() {
      if (this.model.type == "radio") {
        this.model.answer = "other";
      } else if (this.model.type == "checkbox") {
        this.includeOther = true;
      }
      this.onUpdate();
    },
    validate() {
      if (mounted && !canValidate) {
        canValidate = true;
      }

      let valid = true;

      if (canValidate && !this.scoreView) {
        switch (this.model.type) {
          case "radio": {
            valid = this.model.answer != null;
            break;
          }
          case "checkbox": {
            valid = this.model.answer.length > 0;
            break;
          }
          case "text":
          case "short": {
            valid = this.model.answer && this.model.answer.length > 0;
            break;
          }
        }

        if (this.model.type == "radio" || this.model.type == "checkbox") {
          if (this.modelHasOther && this.includeOther) {
            if (this.model.other.length == 0) {
              valid = false;
            } else {
              valid = valid || this.model.other.length > 0;
            }
          }
        }
      }

      this.model.valid = !this.model.required || valid;
      this.$forceUpdate();

      return this.model.valid;
    },
    onUpdate() {
      if (this.model.type == "radio") {
        this.includeOther = this.model.answer == "other";
      } else if (this.model.type == 'generated-courses') {
        let option = _.find(this.model.options, {
            uuid: this.model.answer
        });

        if (option) {
            this.model.other_selected = true;
            this.model.other = option.title;
        }
      }

      //   if (this.model.type == "radio" || this.model.type == "checkbox") {
      //     if (this.model.comment !== null) {
      //     }
      //   }

      this.validate();

      if (this.canEmit) {
        this.$emit("update", this.model);
      }
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/survey/Answer.vue